import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/storage'

// Init
const config = {
    apiKey: "AIzaSyBlMaunsxR3z8SJnHiO-Vh33tCgx1TeW48",
    authDomain: "vanmgl.firebaseapp.com",
    databaseURL: "https://vanmgl.firebaseio.com",
    projectId: "vanmgl",
    storageBucket: "vanmgl.appspot.com",
    messagingSenderId: "452940282655",
    appId: "1:452940282655:web:8be8a09f407594d3a6ce2a",
    measurementId: "G-G42V71WKKJ"
}

firebase.initializeApp(config)

const db = firebase.firestore()
const rdb = firebase.database()
const storage = firebase.storage()
const auth = firebase.auth()
const faceAuthProvider = new firebase.auth.FacebookAuthProvider()
const currentUser = auth.currentUser

// Online Presence
firebase.auth().onAuthStateChanged(user => {

    // console.log('Auth state changed: ', user, currentUser)
    
    if(user === null){
        let userStatusRef = fb.rdb.ref(`/status/${currentUser.uid}`)

        // Disconnected
        userStatusRef.set({
            status: 'offline',
            timestamp: fb.firebase.database.ServerValue.TIMESTAMP
        })
    }
})

// Collections
const usersCollection = db.collection('users')
const eventsCollection = db.collection('events')
const workshopsCollection = db.collection('workshops')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const adsCollection = db.collection('ads')
const ordersCollection = db.collection('orders')
const videosCollection = db.collection('videos')
const activitiesCollection = db.collection('activities')
const storiesCollection = db.collection('stories')

export {
    firebase,
    faceAuthProvider,
    db,
    rdb,
    auth,
    storage,
    currentUser,
    usersCollection,
    eventsCollection,
    workshopsCollection,
    commentsCollection,
    likesCollection,
    adsCollection,
    ordersCollection,
    videosCollection,
    activitiesCollection,
    storiesCollection
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js